<template>
  <div class="boxbig">
    <div class="topitem">
      <div class="imgLeft"></div>
      <div class="image_wrap">
        <div class="logo" />
      </div>
      <div class="imgRight">
        <el-dropdown trigger="click" class="user" v-if="userId">
        <span class="el-dropdown-link">
          {{ phone.substring(0, 3) + "****" + phone.substring(7, 11)
          }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <i v-on:click="logout">退出登录</i>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-link v-else v-on:click="go('/sacrifice/login')" class="user"
        >注册/登录</el-link
      >
      </div>

    </div>

      <div class="navNew">
      <nav class="nav f-db">
      <span
        v-for="(item, index) in navs"
        v-bind:key="index"
        v-on:click="setactive(index, item.name)"
        class="link"
      >
        <router-link
          :to="{ name: item.name, query: { id: item.id } }"
          v-bind:class="active == index ? 'link-active' : 'link-default'"
          >{{ item.categoryTitle }}</router-link
        >
      </span>
    </nav>
    </div>
    <!-- <el-aside class='hots f-pr'> -->

      <!-- <el-carousel  indicator-position='none' :autoplay="true"  ref='hots'>
					<el-carousel-item v-for="(item, index) in imgs" :key="index">
					  <router-link  v-bind:to='""'>
						  <el-image :src="item.url" class='hot-image' fit="cover" style="width:100%;height:100%;"></el-image>
						</router-link>
					</el-carousel-item>
				</el-carousel> -->
    <!-- </el-aside> -->
<!--
    <el-header height="192" class="header f-pr">

    </el-header> -->


  </div>
</template>

<style lang="stylus" scoped>
.boxbig {
  width: 100%;
  height: -4%;
  padding: 0;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  // background: url('/static/image/pic1.png') top center no-repeat;
  // background: url('/static/image/banner_top.png') center center no-repeat;
  background-size: cover;
}
 .topitem {
  width:100%;
  height:216px;
  display: flex;
  justify-content:space-between;
  align-items: center;
  // border:1px solid red;

 }
.imgLeft{
  width:24%;
  height:100%;
  background: url("/static/image/left.png") no-repeat;
  background-size: cover;
  // border:1px solid green;
  // margin-left: -190px;
}
.imgRight{
  width:24%;
  height:100%;
  background: url("/static/image/right.png") no-repeat;
  background-size: 100%;
  // margin-left: -190px;
}
.image_wrap {
  width:48%;
  height:96%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 65px;
  // padding: 40px 0 32px;
  // align-items: self-end;
}

.logo {
  width: 100%;
  height: 80%;
  background: url("/static/image/title2.png") bottom no-repeat;
  background-size: contain;
  // border: 1px solid red
  // margin: 0 20%;
  // margin-top: 70px;
  // margin-bottom: 20px;
  // margin-left: 70px;
  // border: 1px solid red;
}

.banner {
  width: 1200px;
  height: 250px;
  // border: 1px solid red;
}

.navNew {
  height: 46px;
  // background: linear-gradient(180deg, #3781D6, #1E6DCA);
  // background: rgb(160,138,92);
  width: calc(100% - 1px);
  font-size: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  // opacity:0.3;
}
.nav {
  height: 46px;
  // background: linear-gradient(180deg, #3781D6, #1E6DCA);
  background: #8E8E8E;
  color:#FFFFFF;
  width: 1200px;
  font-size: 22px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  // opacity:0.3;
}

.link {
  border-right: #FFFFFF solid 1px;
  // height: 26px;
  // line-height: 50px;
  display: inline-block;

  a {
    padding-left: 36.5px;
    padding-right: 36.5px;
  }
}

.link:last-of-type {
  border-right: none;
}

.link-active {
  color: #FFFFFF;
}

.link-default {
  color: #FFFFFF;
}
.user{
  position: absolute;
  right: 450px;
  font-size: 20px;
}
</style>

<script>
export default {
  name: "cheader",
  props: {},
  data() {
    return {
      imgs: [
        {
          url: "/static/image/one.png",
          id: 0,
          style: {
            background: "#4abf8a",
            width: "23.5%",
            "margin-right": "2%",
          },
        },
        {
          url: "/static/image/two.png",
          id: 1,
          style: {
            background: "#4abf8a",
            width: "23.5%",
            "margin-right": "2%",
          },
        },
        {
          url: "/static/image/three.png",
          id: 2,
          style: {
            background: "#4abf8a",
            width: "23.5%",
            "margin-right": "2%",
          },
        },
        {
          url: "/static/image/four.png",
          id: 3,
          style: {
            background: "#4abf8a",
            width: "23.5%",
            "margin-right": "2%",
          },
        },
        {
          url: "/static/image/fiver.png",
          id: 4,
          style: {
            background: "#4abf8a",
            width: "23.5%",
            "margin-right": "2%",
          },
        },
        // {url:'/static/image/two.png'},
        // {url:'/static/image/three.png'},
        // {url:'/static/image/four.png'},
        // {url:'/static/image/three.png'},
      ],
    };
  },
  computed: {
    userId() {
      return this.$store.state.user.userId;
    },
    phone() {
      return this.$store.state.user.phone;
    },
    navs() {
      return this.$store.state.menu.navs;
    },
    active() {
      sessionStorage.setItem("active", this.$store.state.menu.active);
      return this.$store.state.menu.active;
    },
  },
  mounted() {
    this.getNewsImg()
  },
  methods: {
    getNewsImg() {
      this.$http.get("menu/news").then((res) => {
        console.log(res, "新闻图片和标题");
        this.hots = res.data.data;
      });
    },
    go(url) {
      this.$router.push(url);
    },
    setactive(index, name) {
      sessionStorage.setItem("name", name);
      this.$store.commit("setactive", index);
    },
    logout() {
      this.$confirm("确定退出登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.commit("setoken", "");
        this.$store.commit("setuser", "");
        this.$router.push("/sacrifice/login");
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// index.vue?396925b0